import React from "react";
import { QrCode, ShieldCheck, Lock, ListChecks } from "lucide-react";
import landing from "@/content/landing";
import { Section } from "./HeroSection";

const FEATURE_ICONS = [ShieldCheck, ListChecks, Lock];

export default function TrustCardShowcase() {
  const t = landing.trustCard;
  return (
    <Section id="vertrauenskarte" className="bg-ag-paper" data-testid="landing-trustcard">
      <div className="grid gap-10 lg:grid-cols-12 lg:items-center lg:gap-16">
        <div className="lg:col-span-6">
          <h2 className="font-serif text-3xl leading-tight text-ag-ink sm:text-4xl lg:text-5xl">
            {t.headline}
          </h2>
          <p className="mt-5 text-base leading-relaxed text-slate-700 sm:text-[17px]">{t.text}</p>
          <p className="mt-4 font-serif text-lg italic text-slate-500">{t.hint}</p>

          <ul className="mt-8 space-y-3">
            {t.features.map((f, idx) => {
              const Icon = FEATURE_ICONS[idx] || ShieldCheck;
              return (
                <li key={idx} className="flex items-start gap-3 text-sm text-slate-700">
                  <Icon className="mt-0.5 h-5 w-5 shrink-0 text-amber-600" strokeWidth={1.6} aria-hidden="true" />
                  <span>{f}</span>
                </li>
              );
            })}
          </ul>
        </div>

        <div className="lg:col-span-6">
          {/* Präsentative Karte im Kreditkartenformat */}
          <div className="mx-auto max-w-md">
            <div
              className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 p-6 text-white shadow-xl"
              style={{ aspectRatio: "1.586 / 1" }}
              data-testid="landing-trustcard-visual"
              aria-label="Vorschau der Vertrauenskarte"
            >
              <div className="flex h-full flex-col justify-between">
                <div className="flex items-start justify-between gap-4">
                  <div>
                    <div className="text-[10px] uppercase tracking-[0.28em] text-amber-200/80">
                      Vertrauenskarte
                    </div>
                    <div className="mt-2 font-serif text-lg leading-tight">
                      ALLES GEREGELT.
                    </div>
                  </div>
                  <div
                    className="flex h-14 w-14 shrink-0 items-center justify-center rounded-lg bg-white/95 text-slate-900"
                    aria-hidden="true"
                  >
                    <QrCode className="h-9 w-9" strokeWidth={1.4} />
                  </div>
                </div>

                <div>
                  <div className="text-[10px] uppercase tracking-[0.24em] text-white/60">
                    Notfall-ID
                  </div>
                  <div className="mt-1 font-mono text-base text-white/90">AG-••••-••••</div>
                </div>
              </div>
              <div className="pointer-events-none absolute -right-10 -top-10 h-40 w-40 rounded-full bg-amber-400/20 blur-3xl" aria-hidden="true" />
            </div>
            <p className="mt-4 text-center text-xs uppercase tracking-[0.22em] text-slate-400">
              Beispiel · Darstellung ohne echte Daten
            </p>
          </div>
        </div>
      </div>
    </Section>
  );
}
